export default __webpack_public_path__ + "static/media/full-stack-course-app.f8cb2883.png";